import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { fontStyle } from '../../../theme/helpers/fontStyle';

export const $DatatableFilters = styled.div`
  padding: ${spacing('sm')};
  display: flex;
  flex-direction: row;
  gap: ${spacing('sm')};

  & > *:first-child {
    flex: 1;
  }
`;

export const $BadgeIconButton = styled.div`
  margin-left: ${spacing('lg')};
  border-radius: 50%;
  min-width: ${spacing('xl')};
  min-height: ${spacing('xl')};
  background-color: ${({ theme }) => theme.colors.primary};
  ${fontStyle('xs')};
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${fontWeight('normal')};
`;

export const $SwipeableOverflowContainer = styled.div`
  max-height: calc(100vh - ${spacing(24)});
  overflow: auto;
  overflow-x: hidden;
  margin: 0 calc(-1 * ${spacing('xxl')});
  padding: 0 ${spacing('xxl')};

  @media ${media.maxWidth.xs} {
    max-height: calc(100vh - ${spacing(52)});
  }
`;

export const $DatatableFiltersFooter = styled.div`
  background-color: ${({ theme }) =>
    theme.colors.datatableRowBackgroundHoverColor};
  min-height: 70px;
  margin: 0 calc(-1 * ${spacing('xxl')}) calc(-1 * ${spacing('xxl')});
  padding: ${spacing('lg')} ${spacing('xxl')} ${spacing('sm')};
  border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
`;
